import { Box } from "@mui/material";
import { headerLogo } from "./imagesStyles";
import emSemiCircle from "./emSemiCircle.png";

const HeaderLogo = () => {
  return (
    <Box sx={headerLogo()}>
      <img src={emSemiCircle} alt="" />
    </Box>
  );
};

export default HeaderLogo;
